import { useState } from "react";
import Layout from "../Shared/Layout";
import EventDetailsModal from "./EventDetailsModal ";
import EventForm from "./EventForm/EventForm";
import { EventTables } from './EventTable/EventTables';

export function EventLiason(){
  const [selectedEventForDetails, setSelectedEventForDetails] = useState(null);
  const [refreshTable, setRefreshTable] = useState(false);
   // Callback appelé après la création d’un événement pour rafraîchir le tableau
   const handleEventCreated = () => {
    // Inverser la valeur pour déclencher useEffect dans EventTables
    setRefreshTable(prev => !prev);
  };
    
    return (
        <>
            <Layout>
                <div className="content-body default-height">
                    <div className="container-fluid">
                        <EventForm onEventCreated={handleEventCreated} />
                        <EventTables refresh={refreshTable}/>
                    </div>
                </div>   
            </Layout>

            {selectedEventForDetails && (
              <EventDetailsModal 
                  eventId={selectedEventForDetails.id}
                  onClose={() => setSelectedEventForDetails(null)}
              />
            )}
        </>
    )
}

export default EventLiason;